"use client";

import PacksDashboard from "@/modes/agentic-workflows/rfp-pack/components/PacksDashboard";
import PackTour from "@/modes/agentic-workflows/rfp-pack/components/PackTour";

export default function RfpPacksIndexPage() {
  return <PackTour><PacksDashboard /></PackTour>;
}